import {Injectable} from '@angular/core';
import {AbstractSecurityStorage} from 'angular-auth-oidc-client';

@Injectable()
export class BrowserStorage implements AbstractSecurityStorage {
    constructor() {
    }

    read(key: string): any {
        const item = this.getStorage()?.getItem(key);

        if (!item) {
            return null;
        }

        return JSON.parse(item);
    }

    write(key: string, value: any): void {
        const storage = this.getStorage();

        value = value || null;

        storage.setItem(`${key}`, JSON.stringify(value));
    }

    remove(key: string): boolean {
        const storage = this.getStorage();

        storage.removeItem(`${key}`);

        return true;
    }

    clear(): void {
        const storage = this.getStorage();

        storage.clear();
    }

    private getStorage(): any {
        // return localStorage;
        return sessionStorage;
    }
}
